import { useQuery } from '@tanstack/react-query'
import { getRemakeStatus, getLatestRemake, getRemakeVersions, getRemakeById } from '@/lib/api/amazon-listing'

export function useRemakeStatus(jobId: string | undefined) {
  return useQuery({
    queryKey: ['remake', 'status', jobId],
    queryFn: () => getRemakeStatus(jobId!),
    enabled: !!jobId,
    refetchInterval: (query) => {
      if (query.state.error) return false
      const s = query.state.data?.status
      return s === 'completed' || s === 'failed' ? false : 3000
    },
    retry: 1,
  })
}

export function useLatestRemake(jobId: string | undefined) {
  return useQuery({
    queryKey: ['remake', 'latest', jobId],
    queryFn: () => getLatestRemake(jobId!),
    enabled: !!jobId,
    staleTime: 60_000,
  })
}

export function useRemakeVersions(jobId: string | undefined) {
  return useQuery({
    queryKey: ['remake', 'versions', jobId],
    queryFn: () => getRemakeVersions(jobId!),
    enabled: !!jobId,
  })
}

export function useRemakeById(remakeId: string | undefined) {
  return useQuery({
    queryKey: ['remake', 'byId', remakeId],
    queryFn: () => getRemakeById(remakeId!),
    enabled: !!remakeId,
    staleTime: 60_000,
  })
}
